import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';
import Modal from 'bcl/components/modal';
import ItemEdit from 'bcl/components/item-edit';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type ItemModel from 'bcl/models/item';

export interface BDItemSignature {
  // The arguments accepted by the component
  Args: {
    model: ItemModel;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class BDItemComponent extends Component<BDItemSignature> {
  @service declare router: RouterService;
  closeModal = () => {
    this.router.transitionTo('auth.basic-data');
  };

  <template>
    {{pageTitle "Artikel bearbeiten | Barvera" replace=true}}
    <Modal @size="big">
      <ItemEdit @model={{@model}} @closeModal={{this.closeModal}} />
    </Modal>
  </template>
}
